import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Tennessee Volunteers"
    teamId={teamIds['Tennessee Volunteers']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Volunteers.png"
  />
)
